export enum SipLogMessages {
  SIP_CONNECTING = 'SIP connecting',
  SIP_CONNECTION_SUCCESS = 'SIP connection success',
  SIP_REGISTERED = 'SIP registered',
  SIP_UNREGISTERED = 'SIP unregistered',
  SIP_REGISTRATION_FAILED = 'SIP registration failed',
  SIP_CONNECTION_LOST = 'SIP connection lost',
  RTC_SESSION_FAILED_EVENT = 'RTC session failed event',
  RTC_SESSION_GET_USER_MEDIA_FAILED_EVENT = 'RTC session get user media failed event',
  RTC_SESSION_TERMINATE_ACTION = 'RTC session terminate action',
  RTC_SESSION_REFER_ACTION = 'RTC session refer action',
}
